// extracted by mini-css-extract-plugin
module.exports = {"linkAndButtons":"copy-link_linkAndButtons_LqD","bold":"copy-link_bold_2vg","input":"copy-link_input_2P5","copyLink":"copy-link_copyLink_2lj"};